import { render } from "./RbqmStudySpecReport.vue?vue&type=template&id=81405654&scoped=true"
import script from "./RbqmStudySpecReport.js?vue&type=script&lang=js"
export * from "./RbqmStudySpecReport.js?vue&type=script&lang=js"

import "./RbqmStudySpecReport.vue?vue&type=style&index=0&id=81405654&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-81405654"]])

export default __exports__